import { render } from "./Videos.vue?vue&type=template&id=682f938a&scoped=true"
import script from "./Videos.vue?vue&type=script&lang=js"
export * from "./Videos.vue?vue&type=script&lang=js"

import "./Videos.vue?vue&type=style&index=0&id=682f938a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682f938a"]])

export default __exports__